module.exports = __webpack_public_path__ + "static/media/icon-01.626bbaea.png";